export default {
    1: '80*120*100',
    2: '100*120*100'
}


// WEBPACK FOOTER //
// ./src/models/PalletSize.js